import { Col, Row, Space, Typography } from "antd";
import { motion } from "framer-motion";

import { CAR_IMAGE_2, CAR_IMAGE_1 } from "assets";
import useHeroSection from "./useHeroSection";
import { imageVariants } from "./variants";

const HeroSection = () => {
  const { controlsImage1, controlsImage2 } = useHeroSection();

  return (
    <section className="container hero-section">
      <Row className="flex-1 hero-texts" gutter={[20, 20]}>
        <Col xs={{ span: 24, order: 2 }} md={{ span: 12, order: 1 }}>
          <Space direction="vertical">
            <Typography.Title level={1}>
              HSTC Engineering: Committed to Excellence in Defense and Security
            </Typography.Title>
            <Typography.Text className="font-20">
              HSTC Engineering: Pioneers in Defense and Security Solutions. With
              expertise in Military, Defense, and Security sectors, we integrate
              cutting-edge technology into our services and products,
              prioritizing safety, satisfaction, and integrity.
            </Typography.Text>
          </Space>
        </Col>
        <Col
          xs={{ span: 24, order: 1 }}
          md={{ span: 12, order: 2 }}
          className="car-images"
        >
          <motion.img
            src={CAR_IMAGE_1}
            alt="car-1"
            initial="back"
            animate={controlsImage1}
            variants={imageVariants}
          />
          <motion.img
            src={CAR_IMAGE_2}
            alt="car-2"
            initial="front"
            animate={controlsImage2}
            variants={imageVariants}
          />
        </Col>
      </Row>
    </section>
  );
};

export default HeroSection;
